export default __webpack_public_path__ + "static/media/Ab0.3ca215a3.mp3";